import {DomainEvent} from './DomainEvent';
import {UnfollowedEntity} from '../resources/UnfollowedEntity';

/**
 * Base class for events, that are raised, when a user is following an entity no more.
 */
export abstract class EntityUnfollowedEvent extends DomainEvent<UnfollowedEntity> {}
